// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3MDkc","disabled":"FileBtn_disabled__27uap","warn":"FileBtn_warn__3t5eI","fade":"FileBtn_fade__2FKtA"};